import React from 'react'
import Alert from '../Includes/Dialog/Alert'
import ButtonIconCheck from '../Includes/Button/ButtonIconCheck'
import {
  useDispatch
} from 'react-redux'
import {
  SAVE_SEMAINE
} from '../../Redux/Actions/Semaines'

const SemainesBarSave = ({
  open,
  Commit,
  setOpen
}) => {
  const dispatch = useDispatch()
  return (
    <>
      <Alert
        open={open}
        titre="Confirmation"
        Commit={() => dispatch(SAVE_SEMAINE(true))}
        Cancel={() => {
          setOpen(false)
          dispatch(SAVE_SEMAINE(false))
        }}
        texte={
          <span>
            <span className="block">Cette semaine présente des conflits.</span>
            <span className="block">Voulez-vous quand même enregistrer cette semaine ?</span>
          </span>
        }
      />
      <ButtonIconCheck
        onClick={() => Commit()}
      />
    </>
  )
}

export default SemainesBarSave
